// removed by extract-text-webpack-plugin
module.exports = {"SimpleModal":"Simple-cssmodule-SimpleModal-2j5qQ","title":"Simple-cssmodule-title-3KtIm","contentView":"Simple-cssmodule-contentView-d_fFE","content":"Simple-cssmodule-content-2sQWb","description":"Simple-cssmodule-description-2Gdz_","media":"Simple-cssmodule-media-2VmOP","button":"Simple-cssmodule-button-28JF9","cancelButton":"Simple-cssmodule-cancelButton-2-ozj"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/Simple.cssmodule.less
// module id = 664
// module chunks = 0